import {Typography} from "@mui/material";
import {useLangContext} from "../../../../shared/features/Language";

import imgSrcBad from "shared/assets/img/example-src-bad.webp";
import imgArtBad from "shared/assets/img/example-art-bad.webp";
import imgSrcGood from "shared/assets/img/example-src.webp";
import imgArtGood from "shared/assets/img/example-art.webp";

import imgMarkerBad from "shared/assets/icons/marker-bad.svg";
import imgMarkerGood from "shared/assets/icons/marker-good.svg";

import './itsClear.scss';

export const ItsClearComponent = () => {
  const {textData} = useLangContext();
  return (
   <>
        <Typography
          variant='body1'
          sx={{
            marginBottom: {lg: '40px', xs: '10px'},
          }}
        >{textData.explainSelectionRule}</Typography>

        <div className="its-clear_examples-wrapper">
          <div className="its-clear_example-pair">
            <div className="its-clear_example-item">
              <img src={imgSrcBad} alt="bad source"/>
            </div>
            <div className="its-clear_example-item">
              <img src={imgArtBad} alt="bad art"/>
            </div>
            <div className="its-clear_marker">
              <img src={imgMarkerBad} alt="bad"/>
            </div>
          </div>
          <div className="its-clear_example-pair">
            <div className="its-clear_example-item">
              <img src={imgSrcGood} alt="good source"/>
            </div>
            <div className="its-clear_example-item">
              <img src={imgArtGood} alt="good art"/>
            </div>
            <div className="its-clear_marker">
              <img src={imgMarkerGood} alt="good"/>
            </div>
          </div>
        </div>
     </>
  )
}
